/**
 * `FileReference` URL resolution.
 *
 * Lives in its own module so both `shared/blocks/helpers.ts` and any
 * `shared/blocks/<variant>/helpers.ts` can import it without creating a
 * circular dependency between them.
 *
 * Mirrors the discriminator on `FileReference`:
 *   - `internal` → `https://cdn.putty.me/<fileId>`
 *   - `external` → the original (hot-linked) URL
 */
export function resolveFileUrl(file) {
    return file.type === "external" ? file.url : `https://cdn.putty.me/${file.fileId}`;
}
